import * as t from './actionTypes';

export const initialState = {};

const analyticsReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case t.FETCH_USER_MAPPINGS_RESPONSE:
      return {
        ...state,
        userMappings: action.userMappings,
      };
    default: {
      return state;
    }
  }
};

export default analyticsReducer;
